<nav class="__header-main">
  <div>
    <a [routerLink]="['/consults']" href="#">
      <div class="flex items-center">
        <img src="assets/aly-logo.svg" alt="aly logo" class="app-logo">
        <!-- <span *ngIf="isHospital" class="ml-5 font-bold text-white uppercase italic">for {{displayName}}</span> -->
      </div>
    </a>
  </div>

  <div class="flex justify-center items-center ">
    <div class="relative">
      <button type="button" class="notif-btn" (click)="isNotifPopupOpened = !isNotifPopupOpened">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10 5.36667V8.14167" stroke="#444750" stroke-width="1.25" stroke-miterlimit="10"
            stroke-linecap="round" />
          <path
            d="M10.0167 1.66667C6.95004 1.66667 4.4667 4.15 4.4667 7.21667V8.96667C4.4667 9.53334 4.23337 10.3833 3.9417 10.8667L2.88337 12.6333C2.23337 13.725 2.68337 14.9417 3.88337 15.3417C7.8667 16.6667 12.175 16.6667 16.1584 15.3417C17.2834 14.9667 17.7667 13.65 17.1584 12.6333L16.1 10.8667C15.8084 10.3833 15.575 9.52501 15.575 8.96667V7.21667C15.5667 4.16667 13.0667 1.66667 10.0167 1.66667Z"
            stroke="#444750" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round" />
          <path
            d="M12.775 15.6833C12.775 17.2083 11.525 18.4583 9.99998 18.4583C9.24164 18.4583 8.54164 18.1417 8.04164 17.6417C7.54164 17.1417 7.22498 16.4417 7.22498 15.6833"
            stroke="#444750" stroke-width="1.25" stroke-miterlimit="10" />
        </svg>
        <span class="notif-count"></span>
      </button>

      <div class="menu-block notification-block" *ngIf="isNotifPopupOpened">
        <div class="flex items-center justify-center py-5 bg-white m-2" *ngIf="isNotifLoading">
          <img src="/assets/table-loading.gif" class="w-10 h-10" />
        </div>
        <div class="notification-items">
          <div class="notification-item" *ngFor="let notif of (lastNotification$ | async)"> <!--[ngClass]="{'unread': !notif.isRead}"-->
            <b [innerHTML]="notif.subject"></b>
            <div class="date">{{notif.createdOn | dateFormat}}</div>
            <p>{{notif.message}}</p>
          </div>
        </div>
        <div class="notification-view-all">
          View All
        </div>
      </div>
    </div>

    <div class="relative">
      <button type="button" class="profile-user" (click)="isProfilePopupOpened = !isProfilePopupOpened">
        <img class="profile-picture" src="{{ false || 'assets/avatar.png'}}" alt="user-profile">
        <div class="text-left" *ngIf="(currentUser$ | async) as user">
          <div class="full-name">{{user?.firstName}} {{user?.lastName}}</div>
          <div class="email">{{user?.email}}</div>
        </div>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.6 7.45834L11.1667 12.8917C10.525 13.5333 9.47503 13.5333 8.83336 12.8917L3.40002 7.45834"
            stroke="#444750" stroke-width="1.25" stroke-miterlimit="10" stroke-linecap="round"
            stroke-linejoin="round" />
        </svg>
      </button>
      <div class="menu-block profile-block" *ngIf="isProfilePopupOpened">
        <div class="items">
          <div (click)="onClickChangePassword()" class="item">
            Change password
          </div>
          <div class="item" (click)="logout()">Logout</div>
        </div>
      </div>
    </div>

  </div>

</nav>


<app-modal-popup [title]="'Change Password'" #changePasswordModal id="changePasswordModal">
  <app-change-password (onSuccess)="closeModal()"></app-change-password>
</app-modal-popup>